import React from "react";

const ControlStatusConfirmationModal = ({
  isOpen,
  onConfirm,
  selectedLanguage,
  isCancel
}) => {
  if (!isOpen) return null;

  return (
    <div className="modalCus" id="myModal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <div className="d-flex justify-content-center flex-column my-2 text-center ">
              <div className="mb-3">
                <img
                  src="assets/img/icons/check.png"
                  alt=""
                  className="h-80p"></img>
              </div>
              <h4 className="fw-bold" htmlFor="">
                {selectedLanguage.LstLanguageCodes.UI_ControlStatus}
              </h4>

              <p
                className="w-100 f-w550 mb-1"
                style={{ display: "content" }}>
                {isCancel ? selectedLanguage.LstLanguageCodes.UI_ThePagelockerProperties : selectedLanguage.LstLanguageCodes.UI_TheDocumentProperties}
              </p>
            </div>
          </div>

          <div className="d-flex justify-content-center pb-4 ">
            <button
              type="button"
              className="btn btn-primary px-5 ms-3"
              onClick={(e) => onConfirm()}>
              {selectedLanguage.LstLanguageCodes.UI_OK}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ControlStatusConfirmationModal;
